





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import UserEdit from '@/components/administration/Users/UserEdit.vue';
import ScreenEdit from '@/components/administration/screens/ScreenEdit.vue';

import ScreenService from '@/services/ScreenService';
import UserService from '@/services/UserService';
import Screen from '@/models/Screen';
import { ScreenType } from '@/models/ScreenType';

import DataGrid from '@/components/reusable/datagrid/DataGrid.vue';
import IDataGrid from '@/components/reusable/datagrid/IDataGrid';
import DataGridOptions from '@/components/reusable/datagrid/DataGridOptions';
import ScreenContent from '../../../models/ScreenContent';

@Component({
    components: {
        DataGrid,
        UserEdit,
        ScreenEdit
    }
})
export default class ScreenDetails extends Vue {
    private Id: number = 0;

    private BcItems: any = [];
    private Model: Screen = new Screen();
    private RoleGridOptions: DataGridOptions;

    private SelectedUser: number = 0;
    private SelectedScreen: number = 0;

    constructor() {
        super();
        this.RoleGridOptions = new DataGridOptions();
        this.BcItems = [
            { text: 'Admin', to: '/admin' },
            { text: 'Companies', to: '/admin/companies' }
        ];
    }

    private async created() {
        this.Id = parseInt(this.$route.params['id'], 10);

        await this.LoadScreen(this.Id);
        await this.InitRoleGrid();

        this.BcItems.push({ text: this.Model.CustomerName, to: `/admin/companydetails/${this.Model.CustomerId}` });
        this.BcItems.push({ text: this.Model.Name, to: '' });
    }

    private async InitRoleGrid() {
        this.RoleGridOptions.MethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.roleGetList;
        this.RoleGridOptions.DeleteMethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.roleDelete;
        this.RoleGridOptions.HasDelete = false;
        this.RoleGridOptions.PageSize = 10;
        this.RoleGridOptions.ServerLoad = false;
        this.RoleGridOptions.ShowHeader = false;
        this.RoleGridOptions.GridData = await this.LoadRoles(this.Id, this.Model.CustomerId != null ? this.Model.CustomerId : 0);
        this.RoleGridOptions.Styles.Header = ['detail-header'];
        this.RoleGridOptions.Styles.Cell = ['gridcell'];
        this.RoleGridOptions.Columns = [
            { Title: '', FieldName: 'RoleId', Visible: false },
            { Title: '', FieldName: 'ScreenId', Visible: false },
            { Title: 'Name', FieldName: 'RoleName', Visible: true }
        ];
        (this.$refs.rolesDataGrid as unknown as IDataGrid).Reload(true);
    }

    private async LoadScreen(id: number) {
        const screenService = new ScreenService();
        const response = await screenService.LoadScreen(id);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Model = response.Data;
            }
        }
    }

    private async LoadRoles(id: number, companyId: number): Promise<any> {
        const userService = new UserService();
        const response = await userService.LoadScreenRoles(id, companyId);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
            return [];
        } else {
            if (response.Data != null) {
                return response.Data;
            }
        }
    }

    private async OnEditContent() {
        if (this.Model.Contents.length === 0) {
            const screenService = new ScreenService();
            const response = await screenService.CreateEmptyDashboard(this.Model.Id);
            if (response.Error === true) {
                this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
                return;
            } else {
                if (response.Data != null) {
                    const newContent: ScreenContent = new ScreenContent();
                    newContent.Id = -1;
                    newContent.ScreenId = this.Model.Id;
                    newContent.ScreenType = ScreenType.Dashboard;
                    newContent.ContentId = response.Data.id;
                    this.Model.Contents.push(newContent);
                }
            }
        }

        this.$router.push(`/admin/screens/contents/${this.Model.Contents[0].ContentId}/${this.Id}`);
    }

    private async OnAddRole(roleId: number) {
        const userService = new UserService();
        const response = await userService.AddRoleToScreen(roleId, this.Model.Id != null ? this.Model.Id : 0);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
            return [];
        } else {
            this.$bvToast.toast('Changes were saved successfully.', {
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000,
                toastClass: 'toast-success'
            });
            const rec = this.RoleGridOptions.GridData.find((f: any) => f.RoleId === roleId);
            if (rec != null) {
                rec.ScreenId = this.Model.CustomerId;
            }
        }
    }

    private async OnRemoveRole(roleId: number, screenId: number) {
        const userService = new UserService();
        const response = await userService.RemoveRoleFromScreen(roleId, screenId);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
            return [];
        } else {
            this.$bvToast.toast('Changes were saved successfully.', {
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000,
                toastClass: 'toast-success'
            });
            const rec = this.RoleGridOptions.GridData.find((f: any) => f.RoleId === roleId);
            if (rec != null) {
                rec.ScreenId = null;
            }
        }
    }
}
